import BlurFade from "@/components/magicui/blur-fade";
import { Badge } from "@/components/ui/badge";
import { GeneralProps } from "@/types/types";
import { cn } from "@/utils/utils/helpers";
export function SectionWrapper({
  sectionId,
  className,
  children
}: GeneralProps & {
  sectionId?: string;
}) {
  // INFO: this boundary is used to prevent the inner section content from touching the viewport horizontally

  return <section className={cn("mx-auto mt-8 max-w-7xl px-3", className)} id={sectionId} data-sentry-component="SectionWrapper" data-sentry-source-file="section-structure.tsx">
      {children}
    </section>;
}
export function SectionContent({
  animate = true,
  className,
  children
}: GeneralProps & {
  animate?: boolean;
}) {
  const markup = <div className={cn("rounded-xl border-t bg-gradient-to-b from-background via-background to-transparent py-8 md:border md:px-6 md:dark:border-0 md:dark:border-t lg:px-8", className)}>
      {children}
    </div>;
  return animate ? <BlurFade offset={60} duration={1} data-sentry-element="BlurFade" data-sentry-component="SectionContent" data-sentry-source-file="section-structure.tsx">
      {markup}
    </BlurFade> : <>{markup}</>;
}
export function SectionContentCard({
  animate = true,
  className,
  children
}: GeneralProps & {
  animate?: boolean;
}) {
  const markup = <div className={cn("w-full rounded-xl border bg-card px-4 pb-8 pt-6 md:p-8", className)}>{children}</div>;
  return animate ? <BlurFade offset={60} data-sentry-element="BlurFade" data-sentry-component="SectionContentCard" data-sentry-source-file="section-structure.tsx">{markup}</BlurFade> : <div className="relative" data-sentry-component="SectionContentCard" data-sentry-source-file="section-structure.tsx">{markup}</div>;
}
type SectionHeaderProps = {
  label: string;
  title: string;
  subtitle: string;
  animate?: boolean;
};
export function SectionHeader({
  label,
  title,
  subtitle,
  animate = true
}: SectionHeaderProps) {
  const titleMarkup = <SectionHeading>{title}</SectionHeading>;
  const subtitleMarkup = <p className="mt-4 max-w-sm text-pretty px-4 md:max-w-none md:px-0">{subtitle}</p>;
  return <header className="flex flex-col items-center py-2 text-center" data-sentry-component="SectionHeader" data-sentry-source-file="section-structure.tsx">
      <Badge variant="outline" data-sentry-element="Badge" data-sentry-source-file="section-structure.tsx">{label}</Badge>
      {animate ? <>
          <BlurFade delay={0.25}>{titleMarkup}</BlurFade>
          <BlurFade delay={0.25 * 2}>{subtitleMarkup}</BlurFade>
        </> : <>
          <>{titleMarkup}</>
          <>{subtitleMarkup}</>
        </>}
    </header>;
}
export function SectionHeading({
  className,
  children
}: GeneralProps) {
  return <h2 className={cn("mt-2 max-w-md text-pretty text-center text-2xl font-bold tracking-tight md:max-w-none md:text-4xl", className)} data-sentry-component="SectionHeading" data-sentry-source-file="section-structure.tsx">
      {children}
    </h2>;
}
export function SectionBody({
  className,
  children
}: GeneralProps) {
  return <div className={cn("mt-8 rounded-xl", className)} data-sentry-component="SectionBody" data-sentry-source-file="section-structure.tsx">{children}</div>;
}

// Recycled

// 01 May 2025

// `scroll-mt-[${SECTION_SCROLL_MARGIN}px]`

// 02 May 2025

// export function Section({ label, title, subtitle, sectionId, className, children }: SectionProps) {
//   return (
//     <SectionBoundary sectionId={sectionId}>
//       <SectionWrapper className={className}>
//         <SectionHeader label={label} title={title} subtitle={subtitle} />

//         <SectionBody>{children}</SectionBody>
//       </SectionWrapper>
//     </SectionBoundary>
//   );
// }